module.exports = __webpack_public_path__ + "img/banner_en.d3224627.jpg";